module.exports = __webpack_public_path__ + "media/images/baignoire-e8c36bf5b78d5ab565db7ebee203fe0d.svg";